// List created on 03/12/2025
// List updated on 04/05/2026 MAY THE FORCE BE WITH YOU
// List updated on 07/09/2026 — added 1026OCT ... 0327MAR, dropped everything
// before 0826AUG. Safe to prune: this is only the *suggestion* list for the
// extra-projects comboboxes. The chosen values are stored as a ";"-separated
// string on the order itself and the combobox takes free text, so orders that
// still carry a pruned code keep displaying and saving it.

const instoreOrderPresetComments = [
  "0826AUG",
  "0926SEP",
  "1026OCT",
  "1126GREEN",
  "1226XMAS",
  "1326SALE",
  "0127JAN",
  "0227FEB",
  "0327MAR",
];

export default instoreOrderPresetComments;
